'use client'

import { SiteShell } from '@/components/site/site-shell'
import { PageIntro } from '@/components/site/page-intro'

export default function PrivacyPolicyPage() {
  return (
    <SiteShell>
      <div className="w-full bg-background px-6 pb-20 pt-24 md:pb-32 lg:px-12">
        <div className="mx-auto max-w-3xl">
          <PageIntro
            eyebrow="Legal"
            title="Privacy policy"
            description="How Elementary Creative collects, uses, and protects your information."
          />

          <div className="space-y-10 text-muted-foreground leading-relaxed">
            <p className="text-sm uppercase tracking-[0.15em]">
              Last updated: {new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section>
              <h2 className="mb-4 font-serif text-2xl text-foreground">Introduction</h2>
              <p>
                Elementary Creative (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) operates this website.
                This page informs you of our policies regarding the collection, use, and disclosure of
                personal data when you use our service and the choices you have associated with that data.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-serif text-2xl text-foreground">
                Information collection and use
              </h2>
              <p className="mb-4">
                We collect several different types of information for various purposes to provide and
                improve our service to you.
              </p>
              <ul className="list-inside list-disc space-y-2">
                <li>Personal data (name, email address, phone number)</li>
                <li>Usage data (IP address, browser type, pages visited)</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-4 font-serif text-2xl text-foreground">Security of your data</h2>
              <p>
                The security of your data is important to us but remember that no method of transmission
                over the Internet is 100% secure. While we strive to use commercially acceptable means to
                protect your personal data, we cannot guarantee its absolute security.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-serif text-2xl text-foreground">Contact us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at{' '}
                <a
                  href="mailto:contact@elementarycreative.com"
                  className="text-foreground underline-offset-4 hover:text-accent hover:underline"
                >
                  contact@elementarycreative.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </SiteShell>
  )
}
